import * as ActionTypes from "constants/ActionTypes";

const defaultState = {
  activeChapterId: null,
  embedded: false,
  params: {
    routePrefix: "stories",
    storySlug: "",
  },
  path: "",
};

function route(state = defaultState, action) {
  switch (action.type) {
    case ActionTypes.SET_ROUTE_DATA:
      return action.routeData;
    default:
      return state;
  }
}

export default route;
